import PreviewIcon from '@mui/icons-material/Preview';

import { Box, Tooltip, IconButton, Typography, Modal } from '@mui/material';

import { useState, useEffect } from 'react';

import { VViewerIFrame } from '../VViewerIFrame';

type ModelPreviewModalProps = {
  title: string;
  disabled?: boolean;
  getUrl: () => Promise<string>;
};

const style = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  height: '80%',
  display: 'flex',
  flexDirection: 'column',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export const ModelPreviewModalButton = (props: ModelPreviewModalProps) => {
  const { title, getUrl, disabled } = props;
  const [meshUrl, setMeshUrl] = useState('');
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    if (open) {
      getUrl().then((url) => setMeshUrl(url));
    }
  }, [open]);

  return (
    <>
      <Tooltip title="プレビュー">
        <IconButton
          disabled={disabled}
          color={disabled ? 'default' : 'primary'}
          onClick={handleOpen}
        >
          <PreviewIcon />
        </IconButton>
      </Tooltip>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography variant="h6" color="primary">
            プレビュー: {title}
          </Typography>
          <VViewerIFrame glbUrl={meshUrl} style={{ flex: 1, border: 'none' }} />
        </Box>
      </Modal>
    </>
  );
};

export default ModelPreviewModalButton;
